import React from "react";
import { IconProps } from "./IconProps";

const ChangeLog: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 20"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_11693_20348)">
                <path
                    d="M19.8629 11.25L18.1967 9.58333L16.5296 11.25M18.4463 10C18.4463 14.1421 15.0884 17.5 10.9463 17.5C6.80415 17.5 3.44629 14.1421 3.44629 10C3.44629 5.85786 6.80415 2.5 10.9463 2.5C13.6979 2.5 16.1034 3.98178 17.4084 6.19091M10.9463 5.83333V10L13.4463 11.6667"
                    stroke="#F7F9F9"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11693_20348">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.946289)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ChangeLog;
